import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Amplify from 'aws-amplify'
import { Provider } from 'react-redux'
import { createHashHistory, createBrowserHistory } from 'history'
import { ConnectedRouter } from 'react-router-redux'
import { Routes } from './containers/Routes'
import { AuthHandlerContainer } from './containers/AuthHandler'
import { DrawerContainer } from './containers/DrawerContainer'
import './styles/base.scss'
import { configureStore } from './store/configureStore'
import { AWS_CONFIG } from './config/aws/awsConfig'
import { getCurrentEnvironment } from './diagnostics/EnvironmentType'
import { InterceptorsConfig } from './diagnostics/interceptors/Config'
import * as WindowUtils from './utils/WindowUtils'
const history = process.env.NODE_ENV === 'development' ? createHashHistory() : createBrowserHistory()
export const store = configureStore(history)

Amplify.configure(AWS_CONFIG)
InterceptorsConfig.apply(getCurrentEnvironment())

ReactDOM.render(
    <Provider store={store}>
        <AuthHandlerContainer>
            <DrawerContainer>
                <ConnectedRouter history={history}>
                    <Routes />
                </ConnectedRouter>
            </DrawerContainer>
        </AuthHandlerContainer>
    </Provider>,
    document.getElementById('root')
)
if (WindowUtils.isInIFrame()) {
	let root = document.getElementsByTagName('html').item(0)
	if (root) {
		root.className = 'in-iframe'
	}
}



// WEBPACK FOOTER //
// ./src/index.tsx